import React, { useState } from 'react'
import CollapsableView from '@linqpal/common-frontend/src/ui/CollapsableView'
import { Spacer } from '../../../../ui/atoms'
import { CollapseIcon } from './components'
import { View } from 'react-native'
import { GroupedInvoicItem } from './GroupedInvoiceItem'
import { BtText } from '@linqpal/components/src/ui/BtText'

interface GroupedInvoiceListProps {
  invoices: any[]
  onSelect: (arg: string) => void
  navigation: any
  t: any
}

export const GroupedInvoiceList: React.FC<GroupedInvoiceListProps> = ({
  invoices,
  onSelect,
  navigation,
  t,
}) => {
  const [collapsed, setCollapsed] = useState(true)
  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottomWidth: 1,
          borderBottomColor: '#E6EBEE',
          paddingBottom: 14,
        }}
      >
        <BtText weight={'600'}>
          {invoices.length} {t('InvoiceDetails.Invoices')}
        </BtText>
        <CollapseIcon
          collapsed={collapsed}
          onPress={() => setCollapsed(!collapsed)}
        />
      </View>
      <CollapsableView
        collapsed={collapsed}
        style={{
          borderBottomWidth: 1,
          borderBottomColor: '#E6EBEE',
          paddingBottom: 14,
        }}
      >
        {invoices.map((invoice) => (
          <GroupedInvoicItem
            invoice={invoice}
            key={invoice._id}
            onSelect={onSelect}
            navigation={navigation}
          />
        ))}
      </CollapsableView>
      <Spacer />
    </>
  )
}
